export default __webpack_public_path__ + "static/media/mobilehome.5506f653.png";